module.exports = __webpack_public_path__ + "static/error-ig-4-5f1dd70eb4a8a0c462b26c68b816c13f.png";